module.exports = __webpack_public_path__ + "static/media/bg.887f637f.png";